/**
 * ACIL Intelligence - Verify 2FA Page
 */
import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import api, { formatApiError } from '../utils/api';
import { Shield, AlertCircle } from 'lucide-react';
import '../App.css';

export default function Verify2FA() {
  const { setUser } = useAuth();
  const navigate = useNavigate();
  const [code, setCode] = useState('');
  const [isBackup, setIsBackup] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const endpoint = isBackup ? '/api/auth/verify-2fa-backup' : '/api/auth/verify-2fa';
      const { data } = await api.post(endpoint, { code: code.trim() });
      if (data.user) {
        setUser(data.user);
        navigate('/dashboard');
      }
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page" data-testid="verify-2fa-page">
      <div className="auth-card">
        <div className="auth-logo">
          <div className="auth-logo-icon"><Shield size={22} /></div>
          <span className="auth-logo-text">ACIL Intelligence</span>
        </div>

        <h1 className="auth-title" style={{ fontSize: 22 }}>
          {isBackup ? 'Código de respaldo' : 'Verificación de identidad'}
        </h1>
        <p className="auth-subtitle">
          {isBackup
            ? 'Ingresa uno de tus códigos de respaldo.'
            : 'Ingresa el código de 6 dígitos de tu app de autenticación.'
          }
        </p>

        {error && (
          <div className="auth-error-banner" data-testid="2fa-verify-error">
            <AlertCircle size={16} /><span>{error}</span>
          </div>
        )}

        <form onSubmit={handleSubmit} data-testid="verify-2fa-form">
          <input
            type="text"
            className="acil-input"
            placeholder={isBackup ? 'XXXXXXXX' : '000000'}
            value={code}
            onChange={(e) => {
              const val = isBackup ? e.target.value.toUpperCase() : e.target.value.replace(/\D/g, '');
              setCode(isBackup ? val.slice(0, 8) : val.slice(0, 6));
            }}
            maxLength={isBackup ? 8 : 6}
            style={{ textAlign: 'center', fontSize: 28, fontWeight: 700, letterSpacing: '0.2em', height: 64 }}
            autoFocus
            data-testid="2fa-verify-input"
          />

          <button
            type="submit"
            className="btn-primary"
            disabled={loading || code.length < (isBackup ? 8 : 6)}
            style={{ width: '100%', height: 48, marginTop: 20 }}
            data-testid="verify-2fa-submit-btn"
          >
            {loading ? <><div className="acil-spinner" /> Verificando...</> : 'Verificar'}
          </button>
        </form>

        <div style={{ textAlign: 'center', marginTop: 20 }}>
          <button
            className="btn-ghost"
            onClick={() => { setIsBackup(!isBackup); setCode(''); setError(''); }}
            data-testid="toggle-backup-code-btn"
          >
            {isBackup ? 'Usar código de autenticación' : 'Usar código de respaldo'}
          </button>
        </div>
      </div>
    </div>
  );
}
